
import { CheckCircle2 } from "lucide-react";

interface PremiumSubscriptionBenefitsProps {
  advantages: string[];
}

const PremiumSubscriptionBenefits = ({ advantages }: PremiumSubscriptionBenefitsProps) => {
  return (
    <div className="bg-gradient-to-r from-[#407096]/10 to-[#012846]/10 rounded-lg p-6 mb-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="bg-[#F6C528] p-2 rounded-full">
          <CheckCircle2 className="w-5 h-5 text-[#012846]" />
        </div>
        <span className="font-semibold text-[#012846]">Active Premium Subscription</span>
      </div>
      <p className="text-[#243949] mb-4">
        Your active premium subscription gives you immediate access to follow this strategy at no additional cost.
      </p>
      <ul className="space-y-4">
        {advantages.map((advantage, index) => (
          <li key={index} className="flex items-start gap-3">
            <CheckCircle2 className="w-5 h-5 text-[#517FA4] mt-0.5 flex-shrink-0" />
            <span className="text-[#243949]">{advantage}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PremiumSubscriptionBenefits;
